import { Helper } from '../Helper';
export class CloneFunctionHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.cloneArray);
    }
}

//# sourceMappingURL=CloneFunctionHelper.js.map
